import api from './api';

/**
 * Order Service
 * Handles all order-related API calls to the CMS Backend
 * Base URL: /api/admin/orders
 *
 * NOTE: CMS Backend provides READ-ONLY access to orders.
 * All write operations (status updates, refunds, notes) must be done via Main Backend.
 */
const ORDERS_URL = '/api/admin/orders';

const orderService = {
  /**
   * Get all orders with pagination and filters
   * Response includes stats: { totalOrders, pendingOrders, paidOrders, cancelledOrders }
   * @param {Object} params - Query parameters
   * @param {number} params.page - Page number (0-indexed for Spring)
   * @param {number} params.size - Page size
   * @param {string} params.sort - Sort field and direction (e.g., 'createdAt,desc')
   * @param {string} params.status - Filter by order status
   * @param {string} params.paymentStatus - Filter by payment status
   * @param {string} params.search - Search term
   */
  getOrders: (params = {}) => {
    const { page = 0, size = 10, sort = 'createdAt,desc', status, paymentStatus, search } = params;
    const queryParams = { page, size, sort };
    if (status) queryParams.status = status;
    if (paymentStatus) queryParams.paymentStatus = paymentStatus;
    if (search) queryParams.search = search;
    return api.get(ORDERS_URL, { params: queryParams });
  },

  /**
   * Get single order by ID
   * @param {string} id - Order ID
   */
  getOrder: (id) => {
    return api.get(`${ORDERS_URL}/${id}`);
  },

  /**
   * Get order timeline/history
   * @param {string} id - Order ID
   */
  getOrderTimeline: (id) => {
    return api.get(`${ORDERS_URL}/${id}/timeline`);
  },
};

export default orderService;
